import { Box, CircularProgress, Paper, Stack, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import { Breads } from 'src/components/atoms/BreadCrumbs'
import { useNewsDetail } from 'src/hooks/news/useNews'
import { formatTimestamp } from 'src/utils/firebase'

export const NewsDetailPage = () => {
  const { id } = useParams()
  const { getNews } = useNewsDetail(id ?? '')

  if (getNews.error) {
    console.error(getNews.error)
    return null
  }

  if (getNews.isLoading) {
    return (
      <Box>
        <CircularProgress />
      </Box>
    )
  }

  if (!getNews.data) {
    return (
      <Box>
        <Typography>ニュースが見つかりません</Typography>
      </Box>
    )
  }

  const news = getNews.data

  return (
    <Stack spacing={2}>
      <Breads breadIds={['news', 'newsDetail']} />
      <Typography variant="h5">{news.title}</Typography>
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
        }}
      >
        {formatTimestamp(news.createdAt)}
      </Typography>
      <Paper elevation={3}>
        <Box
          sx={{
            padding: 3,
          }}
        >
          <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
            {news.content}
          </Typography>
        </Box>
      </Paper>
    </Stack>
  )
}
